<span>
  {{ textContent }}
</span>
<cx-icon *ngIf="!hidden && !disabled" class="icon" [class.flipped]="!collapsed" type="ARROW_EXPAND"></cx-icon>
